import React, { useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdClose } from "react-icons/md";
import { Link } from "react-router-dom";

const Header = () => {
  const [mobNav, setMobNav] = useState(false);

  const handleNav = () => {
    setMobNav(!mobNav);
  };

  return (
    <div
      className="px-24 bg-gradient-to-r from-[#000000] to-[#151414b0]"
      style={{ position: "relative", zIndex: 50 }}
    >
      <div className="flex justify-between   h-36 items-center  ">
        <Link to={"/"}>
          <h2 className="md:text-2xl text-lg px-4 mt-2 text-[#ffffff] font-body font-thin">
            Ansa Ali
          </h2>
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex">
          <ul className="flex gap-20 uppercase font-light text-white text-lg ">
            <li className="hover:text-[#39ffde]">
              {" "}
              <Link to={"/"}>Home</Link>
            </li>
            <li className="hover:text-[#39ffde]">
              {" "}
              <Link to={"/projects"}>MERN</Link>
            </li>

            <li className="hover:text-[#39ffde]">
              {" "}
              <Link to={"/portfolio"}>UX/UI </Link>
            </li>
          </ul>
        </div>

        {/* Desktop Resume Link */}
        <div className="hidden md:flex text-lg text-white">
          <Link to={"/resume"}>
            <h2
              className=" p-3 rounded-md border border-[#39ffde]"
              style={{
                boxShadow:
                  "0px -2px 5px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.3)",
              }}
            >
              RESUME
            </h2>
          </Link>
        </div>

        {/* Hamburger Menu for Mobile */}
        <button
          onClick={handleNav}
          aria-label="Toggle navigation"
          className="block md:hidden text-white"
        >
          {mobNav ? <MdClose size={20} /> : <GiHamburgerMenu size={20} />}
        </button>
      </div>

      {/* Mobile Sidebar */}
      <div
        className={`${
          mobNav
            ? "fixed left-0 top-0 w-[60%] h-full   bg-slate-900  ease-in-out duration-1000 translate-x-0"
            : "fixed left-[-100%] "
        }`}
      >
        <h2 className="text-lg pt-10 px-14  text-[#39ffde] font-thin">
          Ansa Ali
        </h2>
        <hr className="border border-[#39ffde22] mt-5" />
        <ul className="pt-4 px-10 uppercase text-[#39ffde] text-sm">
          <li className="p-4 mb-4">
            {" "}
            <Link to={"/"} onClick={()=>setMobNav(!mobNav)}>Home</Link>
          </li>
          <li className="p-4 mb-4">
            {" "}
            <Link to={"/projects"}  onClick={()=>setMobNav(!mobNav)}>MERN</Link>
          </li>
          <li className="p-4  mb-4">
            {" "}
            <Link to={"/portfolio"}  onClick={()=>setMobNav(!mobNav)}>UX/UI</Link>
          </li>

          <li className="mt-10 ml-2 ">
            <span className="shadow-sm p-2 border border-[#39ffde] rounded-md font-normal">
              <Link to={"/resume"}  onClick={()=>setMobNav(!mobNav)}> RESUME</Link>
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Header;
